import React from 'react';
import { Type } from '@spotify-internal/encore-creator-web';
import { CountryListTable } from '../../../../components/Shared/Tables/CountryListTable';
import { CountryDemographics } from '../../../../types';
import { FormattedMessage } from 'react-intl';

type Props = {
  countryData: CountryDemographics[];
};

export function CountryList(props: Props) {
  return (
    <div>
      <Type as="h1" variant={Type.heading3}>
        <FormattedMessage id="episode.country.title" defaultMessage="Country" />
      </Type>
      <div data-qa="episode-demographics-country-list">
        <CountryListTable countryData={props.countryData} />
      </div>
    </div>
  );
}
